import { render, staticRenderFns } from "./ModalInfoResource.vue?vue&type=template&id=37e7a500&"
import script from "./ModalInfoResource.vue?vue&type=script&lang=js&"
export * from "./ModalInfoResource.vue?vue&type=script&lang=js&"
import style0 from "./ModalInfoResource.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports